import React, { useEffect, useState } from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

// Component
import MainCard from '../../../../../components/MainCard';
import Servicos from './Servicos';
import Identificacao from './Identificacao';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { getSessionCookie } from '../../../../../helpers/cookies';

//API
import tipoDeFiscalizacao_api from '../../../../../api/tipoDeFIscalizacao_api';

//Context
import { useAuth } from '../../../../../context/auth';
import OrigemDemanda from './OrigemDemanda';


function initialStateTipoFiscalizacao(secretaria_id) {
  return {
    identificacao: "",
    status: "Ativo",
    permiteFiscalizacaoAvulsa: "false",
    tipoIntegracoes: [],
    roteiroFiscalizacao_Id: "",
    Secretaria_Id: secretaria_id,
    integracoes: [],
    fiscalizaPlanoTrabalho: "false",
    indicarEndereco: "Automático",
    exibirDadosObito: "false",
    considerarDiasNaoUteis: "false",
    permiteReset: "false",
    modeloEmailDividaAtiva_Id: null,
    termoDividaAtiva: null
  }
};

export default function TipoDeFiscalizacaoStepper({ id = null, handleVoltar, editavel = false }) {
  //Dados de autenticação
  const session = getSessionCookie();

  // state para criar / editar
  const [tipoDeFiscalizacao, setTipoDeFiscalizacao] = useState(initialStateTipoFiscalizacao(session.secretaria_Id))

  //Estado de controle do passo ativo
  const [activeStep, setActiveStep] = useState(1);

  // state para loading
  const { setLoading } = useAuth();

  const loadTipoDeFiscalizacaoItem = (id) => {
    if (id != null || tipoDeFiscalizacao?.id != null) {
      setLoading(true);
      tipoDeFiscalizacao_api.getItem(tipoDeFiscalizacao?.id ?? id).then(response => {
        response.data.roteiroFiscalizacao_Id = response.data.roteiroFiscalizacao_Id.toString();
        response.data.tipoIntegracoes = response.data.tipoFiscalizacoesIntegracos.map(x => x.integracao.tipoIntegracao_Id);
        response.data.integracoes = response.data.tipoFiscalizacoesIntegracos.map(x => x.integracao_Id);
        response.data.indicarEndereco = response.data.indicarEndereco ? response.data.indicarEndereco : "Automático";
        response.data.exibirDadosObito = response.data.exibirDadosObito ? response.data.exibirDadosObito.toString() : "false";
        response.data.considerarDiasNaoUteis = response.data.considerarDiasNaoUteis ? response.data.considerarDiasNaoUteis.toString() : "false";
        response.data.permiteReset = response.data.permiteReset ? response.data.permiteReset.toString() : "false";
        response.data.modeloEmailDividaAtiva_Id = response.data.modeloEmailDividaAtiva_Id ? response.data.modeloEmailDividaAtiva_Id.toString() : null

        response.data?.tipoFiscalizacaoServicos?.map(ts => {
          ts.prazoInicial = ts.prazoInicial.toString()
          return ts;
        });

        setTipoDeFiscalizacao(response.data)
      })
        .catch(err => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    loadTipoDeFiscalizacaoItem(id);
  }, [])

  //Função que retorna o valor do passo ativo
  const getContent = () => {
    switch (activeStep) {
      case 1:
        return <Identificacao
          editavel={editavel}
          tipoDeFiscalizacao={tipoDeFiscalizacao}
          setTipoDeFiscalizacao={setTipoDeFiscalizacao}
          loadTipoDeFiscalizacaoItem={loadTipoDeFiscalizacaoItem}
        />
      case 2:
        return <Servicos
          editavel={editavel}
          tipoDeFiscalizacao={tipoDeFiscalizacao}
          setTipoDeFiscalizacao={setTipoDeFiscalizacao}
          loadTipoDeFiscalizacaoItem={loadTipoDeFiscalizacaoItem}
        />
      case 3:
        return <OrigemDemanda
          editavel={editavel}
          tipoDeFiscalizacao={tipoDeFiscalizacao}
          setTipoDeFiscalizacao={setTipoDeFiscalizacao}
          loadTipoDeFiscalizacaoItem={loadTipoDeFiscalizacaoItem}
        />
      default:
        return <></>;
    }
  }

  return <>
    <Button onClick={() => {
      handleVoltar()
    }} className='px-4'>
      <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
      Voltar
    </Button>
    <MainCard>
      <h5 style={{ color: "#666" }}>Cadastro de Tipo de Fiscalização</h5>
      <Nav tabs>
        <NavItem className='ms-2'>
          <NavLink
            role='button'
            style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
            className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
            onClick={() => { setActiveStep(1); }}
          >
            Tipo de Fiscalização
          </NavLink>
        </NavItem>
        <NavItem className='ms-2'>
          <NavLink
            role='button'
            style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
            className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
            onClick={() => {
              if (!tipoDeFiscalizacao.id) {
                showMessage("Aviso", "Salve a identificação para acessar a próxima etapa", "info", null);
                return;
              }
              setActiveStep(2);
            }}
          >
            Tipos de Serviços
          </NavLink>
        </NavItem>
        <NavItem className='ms-2'>
          <NavLink
            role='button'
            style={{ backgroundColor: activeStep == 3 ? "#fff" : "#ccc" }}
            className={`${activeStep == 3 ? "active fw-bold text-success" : "text-secondary "}`}
            onClick={() => {
              if (!tipoDeFiscalizacao.id) {
                showMessage("Aviso", "Salve a identificação para acessar a próxima etapa", "info", null);
                return;
              }
              setActiveStep(3);
            }}
          >
            Origem das Demandas
          </NavLink>
        </NavItem>
      </Nav>
      <div className="mt-4">
        {getContent()}
      </div>
    </MainCard>
  </>;
}